(function () {
  "use strict";

  // Official Nasú lenticular sheets are normalized into transparent ten-frame sprites.
  // A state accepts: { type: "static", source }, { type: "frames", sources, fps },
  // { type: "sprite", source, columns, rows, frameCount, fps }, or a future adapter type.
  var source = window.MemoryFuelNasuAssetSources || {};
  window.MemoryFuelNasuAssets = {
    idle: { type: "sprite", source: source.idle, columns: 10, rows: 1, frames: [0, 0, 0, 0, 1, 4, 7, 0, 0, 5, 2, 8, 0, 0, 6, 9, 3], random: true, minDelay: 5000, maxDelay: 8000 },
    listening: { type: "sprite", source: source.idle, columns: 10, rows: 1, frames: [0, 0, 1, 4, 5, 7], random: true, minDelay: 5500, maxDelay: 10000 },
    thinking: { type: "sprite", source: source.thinking, columns: 10, rows: 1, frameCount: 10, fps: 0.55 },
    talking: { type: "sprite", source: source.talking, columns: 10, rows: 1, frameCount: 10, fps: 0.8 },
    yawning: { type: "sprite", source: source.yawning, columns: 10, rows: 1, frames: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9], fps: 1.75 },
    grabbed: { type: "sprite", source: source.dragging, columns: 2, rows: 1, frames: [0] },
    dragging: { type: "sprite", source: source.dragging, columns: 2, rows: 1, frames: [1] },
    celebrating: { type: "sprite", source: source.talking, columns: 10, rows: 1, frames: [5, 6, 9, 3], fps: 0.7 },
    concerned: { type: "sprite", source: source.thinking, columns: 10, rows: 1, frames: [4, 5, 7, 8], fps: 0.45 },
    confused: { type: "sprite", source: source.thinking, columns: 10, rows: 1, frames: [1, 4, 5, 7], fps: 0.45 },
    sleeping: { type: "sprite", source: source.idle, columns: 10, rows: 1, frames: [6], fps: 1 },
    error: { type: "sprite", source: source.thinking, columns: 10, rows: 1, frames: [7, 4, 5], fps: 0.45 }
  };
})();
